import { flattenArrayUtil } from 'packages/src'

export default function getStyleComponentUtil (style, propStyle) {
  style = style || {}
  propStyle = propStyle || {}
  if (Array.isArray(style)) {
    style = flattenArrayUtil(style)
    style = style.reduce((obj, styleItem) => {
      if (!styleItem) {
        return obj
      }
      Object.keys(styleItem).forEach(key => {
        obj[key] = styleItem[key]
      })
      return obj
    }, {})
  }

  if (Array.isArray(propStyle)) {
    propStyle = flattenArrayUtil(propStyle)
    propStyle = propStyle.reduce((obj, styleItem) => {
      if (!styleItem) {
        return obj
      }
      Object.keys(styleItem).forEach(key => {
        obj[key] = styleItem[key]
      })
      return obj
    }, {})
  }

  return {
    ...style,
    ...propStyle
  }
}
